export const nav = () => {
  $('.menu-toggle').click(function (e) {
    e.stopPropagation();
    $(this).toggleClass('is-active');
    $('body').toggleClass('lock');
  });

  $('#nav a').click(function () {
    $('.menu-toggle').removeClass('is-active');
    $('body').removeClass('lock');
  });

  if (window.location.href.indexOf('#') > -1) {
    $('body').addClass('jumped');
  }

  $('#logo-video')
    .delay(2000)
    .queue(function () {
      $(this).get(0).play();
      $(this).dequeue();
    });

  var logo = new Image();
  logo.src = $('#logo-src').attr('src');

  $('body:not(.home) #logo').append(logo);

  if ($(window).width() < 600) {
    $('.home #logo').append(logo);
  } else {
    $('.home #logo')
      .delay(2000)
      .queue(function () {
        $(this).append(logo);
        $(this).dequeue();
      });
  }
};
